import React from "react";
import { string, oneOf, func } from "prop-types";
import Avatar from "@/components/avatar";
import { useShareholder } from "@/hooks/shares/useShareholder";

const InvestmentAvatar = ({
  investmentId,
  companyId,
  investorName,
  investorTypeOfOwner,
  ...props
}) => {
  const { data: shareholder } = useShareholder(investmentId, { companyId });

  return (
    <Avatar
      type={shareholder?.investorTypeOfOwner ?? investorTypeOfOwner}
      name={shareholder?.investorInformation?.name ?? investorName}
      {...props}
      id={shareholder?.investorId ?? investmentId}
    />
  );
};

InvestmentAvatar.propTypes = {
  investmentId: string,
  companyId: string,
  investorName: string,
  investorTypeOfOwner: string,
  size: oneOf(["xs", "sm", "md"]),
  className: string,
  title: string,
  onClick: func,
};

export default InvestmentAvatar;
